import __base_store from '@/store/__base_store'

/**
 * Store de promociones de vinoteca (modelo `promocion_vinoteca`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'promocion_vinoteca',
	},
})

